<template>
    <div :style="{
        height: height,
        width: width,
    }" style="position:relative">
        <img :src="computedSrc" :style="{
            height: height,
            width: width,
            'object-position': align
        }" style="max-width: 100%; object-fit: cover; position: absolute;" />

        <v-file-input class="invisible-file-input hideDetails" v-model="file" @update:modelValue="saveFile"
            variant="solo" flat :clearable="false" :prepend-icon="null" :accept="['image/*']" :multiple="false"
            :rules="[maxSizeRule]"></v-file-input>

    </div>
</template>


<script>
export default {
    name: "fileInputCard",
    emits: ["save"],

    props: {
        src: {
            default: undefined
        },
        height: {
            default: "120px"
        },
        width: {
            default: "100%"
        },
        align: {
            default: "center"
        },
    },

    data() {
        return {
            file: undefined,

            maxSizeRule: (value) =>
                !value ||
                this.$validFileSize(value) ||
                this.$i18n.t("messages.fileTooBig", { size: "250MB" }),
        };
    },

    computed: {
        computedSrc() {
            if (this.file) {
                return URL.createObjectURL(this.file)
            }

            if (this.src) {
                return this.src
            }

            return "/images/main/background.jpeg"
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
    },

    components: {
    },

    methods: {
        saveFile() {
            this.$emit("save", this.file)
        }
    }
};
</script>
